import React from 'react'
import PropTypes from 'prop-types'
import moment from '../../../../helpers/moment'

import { Link, NavLink } from 'react-router-dom'

export const DayFilter = ({ poolId, activeDate, currentDate }) => {
  activeDate = activeDate || new Date()
  currentDate = currentDate || new Date()

  let beginningOfTheWeek = moment.utc(activeDate).local().startOf('week')
  let dayLinks = []

  for (let i = 0; i < 7; i++) {
    let day = moment.utc(beginningOfTheWeek).local().add(i, 'days')
    let activeCss = day.isSame(activeDate, 'day') ? 'active' : ''

    dayLinks.push(
      <li key={i} className="nav-item">
        <NavLink className={'nav-link ' + activeCss}
          to={'/pools/' + poolId + '/shifts/' + day.format('YYYY-MM-DD')}>
          {day.isSame(currentDate, 'day') && <span className={"fa fa-star mg-r-4"} />}
          {day.format('ddd DD/MM')}
        </NavLink>
      </li>
    )
  }

  return <ul className="nav nav-tabs">
    <li className="nav-item">
      <Link className={'nav-link'} id="GoToPrevWeek"
        to={'/pools/' + poolId + '/shifts/' + beginningOfTheWeek.add(-6, 'days').format('YYYY-MM-DD')} >
        <span className="fa fa-angle-double-left" />
      </Link>
    </li>
    {dayLinks}
    <li className="nav-item">
      <Link className={'nav-link'} id="GoToNextWeek"
        to={'/pools/' + poolId + '/shifts/' + beginningOfTheWeek.add(14, 'days').format('YYYY-MM-DD')} >
        <span className="fa fa-angle-double-right" />
      </Link>
    </li>
  </ul>
}

DayFilter.propTypes = {
  poolId: PropTypes.string.isRequired,
  activeDate: PropTypes.string,
  currentDate: PropTypes.instanceOf(Date)
}



// WEBPACK FOOTER //
// ./src/containers/pools/details/shifts/dayFilter.js